
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcSource as ObcSourceElement} from '@oicl/openbridge-webcomponents/dist/automation/source/source.js';
 
 
 

 
 export const ObcSource = createComponent({
   react: React,
   tagName: 'obc-source',
   elementClass: ObcSourceElement,
   events: {
     
   }
  });
 
 